import React from "react";

function Notesonwall() {
  return (
    
      <svg
        width="80"
        height="80"
        viewBox="0 0 106 106"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_211_107)">
          <path
            d="M29.4954 106C28.8623 106 28.2398 105.806 27.7141 105.438C27.0394 104.965 26.58 104.244 26.4371 103.433L23.8797 88.9288C23.7466 88.1744 23.8971 87.3977 24.3022 86.7474L60.924 27.9738C61.39 27.2256 62.1523 26.7109 63.0204 26.5579L90.8506 21.6507C92.5404 21.3534 94.1502 22.4807 94.4482 24.1696L105.952 89.4127C106.25 91.1018 105.122 92.7123 103.433 93.0102L30.0347 105.953C29.8554 105.984 29.6749 106 29.4954 106Z"
            fill="#298CFF"
          />
          <path
            d="M94.4481 24.1696C94.1504 22.4807 92.5404 21.3534 90.8506 21.6507L63.0204 26.5577C62.1523 26.7107 61.39 27.2256 60.924 27.9736L52.9997 40.6915V101.903L103.433 93.0102C105.122 92.7125 106.25 91.1018 105.952 89.4127L94.4481 24.1696Z"
            fill="#0085FF"
          />
          <path
            d="M75.0987 104.4C74.8325 104.4 74.5621 104.366 74.2929 104.294L2.30176 85.0036C1.50614 84.7906 0.827914 84.2701 0.416131 83.5567C0.0043484 82.8435 -0.107241 81.9957 0.105793 81.2003L17.2526 17.2081C17.6965 15.5515 19.3991 14.5681 21.056 15.0124L93.0472 34.3024C93.8428 34.5154 94.521 35.0359 94.9328 35.7493C95.3446 36.4628 95.4562 37.3103 95.2431 38.1057L78.0965 102.098C77.7247 103.485 76.4697 104.4 75.0987 104.4Z"
            fill="#78A6FF"
          />
          <path
            d="M93.0472 34.3021L52.9997 23.5715V98.588L74.2931 104.294C74.5623 104.366 74.8325 104.4 75.0989 104.4C76.4699 104.4 77.7249 103.485 78.0965 102.098L95.2431 38.1055C95.4562 37.3098 95.3446 36.4623 94.9328 35.749C94.521 35.0358 93.8426 34.5153 93.0472 34.3021Z"
            fill="#298CFF"
          />
          <path
            d="M72.9523 65.1898C72.6862 65.1898 72.4158 65.1552 72.1465 65.0832L24.1524 52.2231C22.4957 51.7792 21.5128 50.0764 21.9566 48.4197C22.4005 46.7631 24.1031 45.7795 25.76 46.224L73.7541 59.0841C75.4107 59.5279 76.3937 61.2308 75.9499 62.8874C75.5782 64.2745 74.3232 65.1898 72.9523 65.1898Z"
            fill="#D7DDE1"
          />
          <path
            d="M76.167 53.1911C75.901 53.1911 75.6306 53.1566 75.3613 53.0845L27.3674 40.2244C25.7107 39.7806 24.7277 38.0777 25.1716 36.4211C25.6155 34.7644 27.3175 33.7808 28.9749 34.2253L76.9691 47.0854C78.6257 47.5293 79.6087 49.2321 79.1648 50.8888C78.793 52.2761 77.5382 53.1911 76.167 53.1911Z"
            fill="#D7DDE1"
          />
          <path
            d="M69.7371 77.1881C69.471 77.1881 69.2006 77.1536 68.9313 77.0815L20.9372 64.2214C19.2805 63.7776 18.2975 62.0747 18.7414 60.4181C19.1853 58.7614 20.8877 57.778 22.5448 58.2223L70.5389 71.0824C72.1955 71.5263 73.1785 73.2291 72.7346 74.8858C72.363 76.2731 71.1082 77.1881 69.7371 77.1881Z"
            fill="#D7DDE1"
          />
          <path
            d="M19.3298 70.221C17.6725 69.7767 15.9701 70.7603 15.5264 72.4167C15.0826 74.0734 16.0656 75.7762 17.7222 76.2201L46.7188 83.9898C48.3755 84.4337 50.0783 83.4505 50.5222 81.794C50.9661 80.1374 49.9829 78.4345 48.3264 77.9906L19.3298 70.221Z"
            fill="#D7DDE1"
          />
          <path
            d="M73.7542 59.0839L52.9997 53.5228V59.9528L72.1466 65.0832C72.4159 65.1555 72.6861 65.1899 72.9523 65.1899C74.3235 65.1899 75.5783 64.2748 75.9499 62.8873C76.3938 61.2306 75.4108 59.5278 73.7542 59.0839Z"
            fill="#F8F8F8"
          />
          <path
            d="M76.9689 47.0854L52.9997 40.6627V47.0927L75.3616 53.0846C75.6309 53.1568 75.9011 53.1912 76.1673 53.1912C77.5385 53.1912 78.7933 52.2761 79.1649 50.8886C79.6088 49.2322 78.6256 47.5293 76.9689 47.0854Z"
            fill="#F8F8F8"
          />
          <path
            d="M70.539 71.0825L52.9997 66.3827V72.8127L68.9316 77.0817C69.2009 77.1539 69.4711 77.1883 69.7373 77.1883C71.1085 77.1883 72.3633 76.2732 72.735 74.8857C73.1788 73.2292 72.1956 71.5264 70.539 71.0825Z"
            fill="#F8F8F8"
          />
          <path
            d="M52.9972 38.2915C51.5944 38.2915 50.322 37.3344 49.9802 35.9105L45.2156 16.0659C44.8152 14.3981 45.8424 12.7217 47.5101 12.3213C49.1783 11.9203 50.8545 12.9482 51.2547 14.6159L56.0193 34.4604C56.4197 36.1283 55.3924 37.8046 53.7247 38.205C53.4811 38.2636 53.237 38.2915 52.9972 38.2915Z"
            fill="#FFFBF4"
          />
          <path
            d="M52.9997 21.8834V38.2915C53.2388 38.2913 53.4819 38.2635 53.7247 38.2051C55.3924 37.8047 56.4198 36.1282 56.0192 34.4606L52.9997 21.8834Z"
            fill="#F9F4C8"
          />
          <path
            d="M46.7888 18.6329C41.6518 18.6329 37.4724 14.4536 37.4724 9.31653C37.4724 4.17946 41.6518 0.00012207 46.7888 0.00012207C51.9259 0.00012207 56.1052 4.17946 56.1052 9.31653C56.1052 14.4536 51.9259 18.6329 46.7888 18.6329Z"
            fill="#93C6EC"
          />
          <path
            d="M52.9997 2.38013V16.2533C54.9042 14.5463 56.1052 12.0696 56.1052 9.31671C56.1052 6.56381 54.9042 4.0871 52.9997 2.38013Z"
            fill="#6BA7FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_211_107">
            <rect width="106" height="106" fill="white" />
          </clipPath>
        </defs>
      </svg>
   
  );
}

export default Notesonwall;
